import { render } from "./App.vue?vue&type=template&id=33ddfcee"
const script = {}

import "./App.vue?vue&type=style&index=0&id=33ddfcee&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__